import { render } from "./HealthGoalIncomplete.vue?vue&type=template&id=f4a70ae4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__